module.exports = __webpack_public_path__ + "img/NicheWhite.b29c2101.png";